import { createRouter, createWebHistory } from "vue-router";
import { ElMessage } from "element-plus";
import { getToken, isAdminToken } from "../auth/token.js";

const routes = [
  { path: "/", name: "home", component: () => import("../views/HomeView.vue") },
  { path: "/gallery", name: "gallery", component: () => import("../views/GalleryView.vue") },
  { path: "/login", name: "login", component: () => import("../views/LoginPage.vue") },
  { path: "/register", name: "register", component: () => import("../views/RegisterPage.vue") },
  { path: "/admin/login", name: "admin-login", component: () => import("../views/AdminLoginPage.vue") },
  {
    path: "/admin",
    component: () => import("../views/admin/AdminLayout.vue"),
    meta: { requiresAdmin: true },
    children: [
      { path: "", name: "admin-index", redirect: { name: "admin-dashboard" } },
      {
        path: "dashboard",
        name: "admin-dashboard",
        component: () => import("../views/admin/AdminDashboard.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "images",
        name: "admin-images",
        component: () => import("../views/admin/AdminImages.vue"),
        meta: { requiresAdmin: true },
      },

      {
        path: "users",
        name: "admin-users",
        component: () => import("../views/admin/AdminUsers.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "storage",
        name: "admin-storage",
        component: () => import("../views/admin/AdminStorage.vue"),
        meta: { requiresAdmin: true },
      },

      {
        path: "logs",
        name: "admin-logs",
        component: () => import("../views/admin/AdminLogs.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "site",
        name: "admin-site",
        component: () => import("../views/admin/AdminSiteSettings.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "change-password",
        name: "admin-change-password",
        component: () => import("../views/admin/AdminChangePassword.vue"),
        meta: { requiresAdmin: true },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const publicRoutes = ["gallery"];
const guestRoutes = ["login", "register", "admin-login"];

router.beforeEach((to) => {
  const isAdminPath = to.path.startsWith("/admin");
  
  if (isAdminPath && to.name === "admin-login") {
    if (getToken() && isAdminToken()) {
      return { name: "admin-dashboard" };
    }
    return true;
  }
  
  if (guestRoutes.includes(to.name) && getToken()) {
    if (isAdminToken()) {
      return { name: "admin-dashboard" };
    }
    return { path: "/" };
  }
  
  if (guestRoutes.includes(to.name)) return true;
  
  if (publicRoutes.includes(to.name)) return true;
  
  if (!getToken()) {
    if (isAdminPath) {
      return { name: "admin-login", query: { redirect: to.fullPath } };
    }
    return { name: "login", query: { redirect: to.fullPath } };
  }
  
  if (to.matched.some((r) => r.meta.requiresAdmin)) {
    if (!isAdminToken()) {
      ElMessage.warning("需要管理员权限");
      return { name: "admin-login" };
    }
  }
  
  return true;
});

export default router;
